export * from './aside.directive';



// WEBPACK FOOTER //
// D:/desv/producao/ITN/srvHCWaba/src/app/directives/aside/index.ts